import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, ButtonToolbar, Button, ButtonGroup, Table, Tabs, Tab, Spinner } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import ModalApproval from './ModalApproval';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';
import ModalHistoric from './ModalHistoric';
import Pagination from 'react-js-pagination';
import { Trans } from 'react-i18next';
import { parseDateBR } from 'helpers/date';
import { Link } from 'react-router-dom'
import { useQuery } from 'helpers/Hooks'

import './style.css'; 
const InvoiceApprovalListing = () => {
  const query = useQuery()
  const user = useSelector(state => state.user ? state.user : null);
  const profile = user.profiles[0]?user.profiles[0]:null;
  const defaultFilters = {
    per_page: 12, 
    page: 1, 
    //profile_id: 5,//marketing
    //profile_id: 9,//diretor
  };

  const [data, setData] = useState({ data: [] });
  const [data2, setData2] = useState({ data: [], pagination:{} });
  const [filters, setFilters] = useState(defaultFilters);
  const [dataSelected, setDataSelected] = useState(null);
  const [modalSelected, setModalSelected] = useState(null);
  const [displayMode, setDisplayMode] = useState(1);
  const [load, setLoad] = useState(false);
  const [is_event, setIsEvent] = useState(query.get("type") == "events" ? 1 : 0);
  const [show, setShow] = useState(false);

  const handlePageChange = (page) => handleFilterChange({ page });

  useEffect(() => {
    async function connection(){
      setLoad(true);
      let data = await api.get('invoices', { params: { 
        status_id: 6, 
        profile_id: profile?profile.id:null,
        __is_event: is_event
      }});
      data = data.data;
      setData({data:Object.values(data)});

      let data2 = await api.get('invoices', { params: {...filters, __is_event: is_event} });
      setData2(data2.data);


      setLoad(false);
    }
    connection();
  }, [is_event]);

  useEffect(() => {
    async function connection(){
      setLoad(true);
      let data = await api.get('invoices', { params: {...filters, __is_event: is_event} });
      setData2(data.data);
      setLoad(false);
    }
    connection();
  }, [filters]);

  const handleUpdate = () => {
    api.get('invoices', { params: {
        status_id: 6, 
        profile_id: profile?profile.id:null,
        __is_event: is_event
      } })
      .then(({ data }) => {
        setData({data:Object.values(data)});
        setLoad(false);
      });

    api.get('invoices', { params: {...filters, __is_event: is_event} })
      .then(({ data }) => {
        setData2(data);
        setLoad(false);
      });
  }

  const { t } = useTranslation();
  let dialog;

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  const isApprove = (list) => {
    let profile_id = parseInt(profile?profile.id:null);
    //let user_id = localStorage.getItem('user_id');
    let retorno = null;
    list.forEach(a=>{
      if(a.profile_id === profile_id && a.status_id === 8){
        retorno = a;
      }
    })
    return retorno;
  }

  const getStatusIcon = (data, modal_id) => {
    if(modal_id == 1){
      let profile_id = profile?profile.id:null;
      let user_id = parseInt(user.id);
      let aux = isApprove(data.approval_history);
      if(aux){
        return <i className="fas fa-check-circle" style={{size:'7x', color:displayMode==1?'white':'green'}} 
        data-tip={`Aprovada por Gerente de Marketing - ${getDate(aux.updated_at)}`}></i>;
      }else{
        return <i className="fas fa-exclamation-triangle" style={{size:'7x', color:displayMode==1?'white':'orange'}} 
        data-tip="Aguardando Aprovação"></i>;
      }
    } else {
      let aux = data.status_id;
      if(aux == 8){
        return <i className="fas fa-check-circle" style={{size:'7x', color:displayMode==1?'white':'green'}} 
        data-tip={`Aprovada`}></i>;
      }else if(aux == 6){
        return <i className="fas fa-exclamation-triangle" style={{size:'7x', color:displayMode==1?'white':'orange'}} 
        data-tip="Aguardando Aprovação"></i>;
      } else {
        return <i className="fas fa-times" style={{size:'7x', color:displayMode==1?'white':'red'}} 
        data-tip="Reprovado"></i>;
      }
    }
  }

  const handleHideModal = () =>{
    setDataSelected(null);
    setShow(false);
  };

  const getDate = (data) => {
    const date = new Date(data)
    const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' }) 
    const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 

    return `${day}/${month}/${year }`;
  };

  const renderItems = (data,modal_id,load) => {
    if(load) return <Row className="justify-content-md-center"><Col xs="auto">
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </Col></Row>;
    if(data.data.length === 0 && !load) return <Row className="justify-content-md-center"><Col xs="auto">
      Sem dados no momento
    </Col></Row>;
    return <>{displayMode === 1 ?(
      <Row>
        {data.data.length > 0 && !load ? (<>
          {data.data.map((a,k)=>{
            return(
              <Col xs='4' key={k} className="pb-2 nf mb-3">
                <Card className={'card-border h-100'}>
                  <Card.Header className="header_card">
                    <Row className="justify-content-between">
                      <Col>
                        {`#${a.id}-${a.service_provider} - ${a.is_advance ? "Adiantamento" : ''}`}
                      </Col>
                      <Col className="col-auto">
                        {getStatusIcon(a,modal_id)}
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      {!is_event?(<>
                        <Col xs='12'><b>Ação: </b>
                        {a.action_id?
                          (<a href={'../actions/edit/'+a.action.id} target="_blank">{a.action.name+' - #'+a.action.id}</a>):'---'
                        }</Col>
                      </>):(<>
                        <Col xs='12'><b>Evento: </b>
                        {a.event_id?
                          (<a href={'../events/edit/'+a.event.id} target="_blank">{a.event.name+' - #'+a.event.id}</a>):'---'
                        }</Col>
                      </>)}
                      <Col xs='12'><b>Valor: </b>
                      {getcurrency(a)}
                      </Col>
                      <Col xs='12'><b>Data de Criação: </b>
                      {parseDateBR(a.created_at)}
                      <ReactTooltip />
                      </Col>
                      <Button className="eye-icon" onClick={()=>{
                        setDataSelected(a);
                        setModalSelected(modal_id);
                        setShow(true);
                      }}><i className="fas fa-eye"></i></Button>
                      {/* <i className="fas fa-eye eye-icon" onClick={a2=>{
                        setDataSelected(a);
                      }}></i> */}
                      {/* <Col xs='12'><b>Aprovações: </b>
                      </Col> */}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </>) : (<></>)}
      </Row>
    ):(
      <Row>
        <Col>
          <Table striped bordered>
            <thead className="text-center">
              <th>ID</th>
              <th>Nome</th>
              <th>{is_event?'Evento':'Ação'}</th>
              <th>Valor</th>
              <th>Data de Criação</th>
              <th>Status</th>
              <th ></th>
            </thead>
            <tbody className="text-center">
              {data.data.length > 0 && !load ? (<>
                {data.data.map((a,k)=>{
                  return(
                    <tr key={k}>
                      <td>{a.id}</td>
                      <td>{a.service_provider}</td>
                      {is_event?(
                      <td>{a.event_id?
                      (<a href={'../events/edit/'+a.event.id} target="_blank">{a.event.name+' - #'+a.event.id}</a>):'---'
                      }</td>  
                      ):(
                      <td>{a.action_id?
                      (<a href={'../actions/edit/'+a.action.id} target="_blank">{a.action.name+' - #'+a.action.id}</a>):'---'
                      }</td>
                      )}
                      <td>{getcurrency(a)}</td>
                      <td>{parseDateBR(a.created_at)}</td>
                      <td><ReactTooltip />{getStatusIcon(a,modal_id)}</td>
                      <td><Button onClick={()=>{
                        setDataSelected(a);
                        setModalSelected(modal_id);
                        setShow(true);
                      }}><i className="fas fa-eye"></i></Button></td>
                    </tr>
                  );
                })}
              </>) : (<></>)}
            </tbody>
          </Table>
        </Col>
      </Row>
    )}</>;
  };

  const getcurrency = (data) => {
    switch (data.currency) {
      case 1:
        return data.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        break;
      case 2:
        return data.value.toLocaleString('pt-BR', { style: 'currency', currency: 'USD' });
        break;
      case 3:
        return data.value.toLocaleString('pt-BR', { style: 'currency', currency: 'EUR' });
        break;
      default:
        return data.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        break;
    }
  };

  const renderTopBar = (handleCancelToken) => {
    return <Row className="pb-3 justify-content-end">
      <Col xs="auto">
        <ButtonToolbar>
          <ButtonGroup size="sm" className="mr-2">
            <Button disabled={!is_event} onClick={()=>{
              setIsEvent(0)
              handleCancelToken()
            }}>
              <Link style={{color: "white"}} to="/files/approve-invoice?type=actions">Ações</Link>
            </Button>
            <Button disabled={is_event} onClick={()=>{
              setIsEvent(1)
              handleCancelToken()
            }}>
              <Link style={{color: "white"}} to="/files/approve-invoice?type=events">Eventos</Link>
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      </Col>
      <Col xs="auto">
        <ButtonToolbar>
          <ButtonGroup size="sm" className="mr-2">
            <Button disabled={displayMode===1} onClick={()=>setDisplayMode(1)}><i class="fas fa-th"></i></Button>
            <Button disabled={displayMode===2} onClick={()=>setDisplayMode(2)}><i class="fas fa-list"></i></Button>
          </ButtonGroup>
        </ButtonToolbar>
      </Col>
    </Row>
  }

  return (
    <>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Card.Body className="shadow bg-white rounded mb-3">
      <Tabs
        defaultActiveKey="approval"
        id="uncontrolled-tab-example"
        className="mb-3"
        mountOnEnter
      >
        <Tab eventKey="approval" title='Aprovação'>
            <Row className="">
              <Col>
                <h4>{t('title:invoice approval')}</h4>
              </Col>
            </Row>
            <Row className="pb-3 justify-content-end">
              <Col xs="auto">
                <ButtonToolbar>
                  <ButtonGroup size="sm" className="mr-2">
                    {/* <Button to="" disabled={!is_event} onClick={()=>setIsEvent(0)}>Ações</Button>
                    <Button to="/files/approve-invoice?type=events" disabled={is_event} onClick={()=>setIsEvent(1)}>Eventos</Button> */}
                    <Button disabled={!is_event} onClick={()=>setIsEvent(0)}>
                      <Link style={{color: "white"}} to="/files/approve-invoice?type=actions">Ações</Link>
                    </Button>
                    <Button disabled={is_event} onClick={()=>setIsEvent(1)}>
                      <Link style={{color: "white"}} to="/files/approve-invoice?type=events">Eventos</Link>
                    </Button>
                  </ButtonGroup>
                </ButtonToolbar>
              </Col>
              <Col xs="auto">
                <ButtonToolbar>
                  <ButtonGroup size="sm" className="mr-2">
                    <Button disabled={displayMode===1} onClick={()=>setDisplayMode(1)}><i className="fas fa-th"></i></Button>
                    <Button disabled={displayMode===2} onClick={()=>setDisplayMode(2)}><i className="fas fa-list"></i></Button>
                  </ButtonGroup>
                </ButtonToolbar>
              </Col>
            </Row>
            {renderItems(data,1)}
            {
              dataSelected && modalSelected == 1?(
              <ModalApproval 
              data={dataSelected} 
              show={true} 
              handleHideModalAUX={handleHideModal}
              handleUpdate={handleUpdate}
              showBtns={!isApprove(dataSelected.approval_history)}
              user={user}
              setLoad={setLoad}
              is_event={is_event}
              renderTopBar={renderTopBar}
              renderItems={renderItems}
              dataSelected={dataSelected}
              modalSelected={modalSelected}
              handleHideModal={handleHideModal}
              />
            ):''
            }
        </Tab>
        <Tab eventKey="historic" title='Histórico'>
          <Row className="">
            <Col>
              <h4>Histórico de Notas Fiscais</h4>
            </Col>
          </Row>
          <Row className="pb-3 justify-content-end">
            <Col xs="auto">
              <ButtonToolbar>
                <ButtonGroup size="sm" className="mr-2">
                  <Button disabled={!is_event} onClick={()=>setIsEvent(0)}>
                    <Link style={{color: "white"}} to="/files/approve-invoice?type=actions">Ações</Link>
                  </Button>
                  <Button disabled={is_event} onClick={()=>setIsEvent(1)}>
                    <Link style={{color: "white"}} to="/files/approve-invoice?type=events">Eventos</Link>
                  </Button>
                </ButtonGroup>
              </ButtonToolbar>
            </Col>
            <Col xs="auto">
              <ButtonToolbar>
                <ButtonGroup size="sm" className="mr-2">
                  <Button disabled={displayMode===1} onClick={()=>setDisplayMode(1)}><i className="fas fa-th"></i></Button>
                  <Button disabled={displayMode===2} onClick={()=>setDisplayMode(2)}><i className="fas fa-list"></i></Button>
                </ButtonGroup>
              </ButtonToolbar>
            </Col>
          </Row>
          {renderItems(data2,2)}
          {
            dataSelected && modalSelected == 2?(
            <ModalHistoric 
            data={dataSelected}
            handleHideModalAUX={handleHideModal}
            show={show} 
            user={user}/>
            ):''
          }
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: data2.pagination.from || '0' }} to {{ to: data2.pagination.to || '0' }}{' '}
                from {{ total: data2.pagination.total }} records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={data2.pagination.current_page?data2.pagination.current_page:0}
                itemsCountPerPage={data2.pagination.per_page?parseInt(data2.pagination.per_page):0}
                totalItemsCount={data2.pagination.total?data2.pagination.total:0}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item teste"
                linkClass="page-link teste"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Tab>
      </Tabs>
      </Card.Body>
    </>
  );
};

export default MasterPage(InvoiceApprovalListing);